import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { LINKS } from "../data/content";

export const FloatingWhatsApp = () => (
    <motion.a
        href={LINKS.whatsappChat}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat dengan Panitia via WhatsApp"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.6, duration: 0.6, ease: "easeOut" }}
        className="hidden lg:inline-flex fixed bottom-7 right-7 z-40 items-center gap-3 rounded-full bg-bh-green pl-4 pr-6 py-3.5 text-white shadow-[0_16px_40px_rgba(16,134,108,0.4)] transition-all duration-300 hover:bg-bh-dark hover:-translate-y-1"
    >
        <span className="flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
            <MessageCircle className="w-5 h-5" aria-hidden="true" />
        </span>
        <span className="text-sm font-bold tracking-wide">Chat dengan Panitia</span>
    </motion.a>
);
